import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const AncientLibrary = {
  id: '160',
  name: "Mansa's Treasury",
  width: 3,
  height: 3,
  type: BuildingType.EVENT,
  era: 'stoneAge',
  icon: 'Mansas_Treasury',
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Mansa%27s_Treasury',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.GOLD_PRODUCTION_MOD,
      EffectAmount.asFlat(5),
      '%',
    ),
    new PassiveAura(
      PassiveAuraType.HEAVY_INFANTRY_HIT_POINT_MOD,
      EffectAmount.asPerLevel([1.6,1.8,1.9,2,2.1,2.2,2.4,2.5,2.6,2.8,2.9,3,3.1,3.2,3.4,3.5,3.6,3.8,3.9,4,4.1,4.2,4.4,4.5,4.6,4.8,4.9,5,5.1,5.2,5.4,5.5,5.6,5.8,5.9,6,6.1,6.2,6.4,6.5,6.6,6.8,6.9,7,7.1,7.2,7.4,7.5,7.6,7.8,7.9,8,8.1,8.2,8.4,8.5,8.6,8.8,8.9,9]),
      '%',
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerEraAndLevel({
        stoneAge: [
          36,40,43,47,50,54,57,61,64,68,71,75,78,82,85,89,92,96,99,103,106,110,113,117,120,124,127,131,134,138,141,145,148,152,155,159,162,166,169,173,176,180,183,187,190,194,197,201,204,208,211,215,218,222,225,229,232,236,239,243
        ],
        bronzeAge: [
          36,40,43,47,50,54,57,61,64,68,71,75,78,82,85,89,92,96,99,103,106,110,113,117,120,124,127,131,134,138,141,145,148,152,155,159,162,166,169,173,176,180,183,187,190,194,197,201,204,208,211,215,218,222,225,229,232,236,239,243
        ],
        minoanEra: [
          46,50,54,58,62,66,70,74,78,82,86,90,94,98,102,106,110,114,118,122,126,130,134,138,142,146,150,154,158,162,166,170,174,178,182,186,190,194,198,202,206,210,214,218,222,226,230,234,238,242,246,250,254,258,262,266,270,274,278,282
        ],
        classicGreece: [
          55,60,64,69,73,78,82,87,91,96,100,105,109,114,118,123,127,132,136,141,145,150,154,159,163,168,172,177,181,186,190,195,199,204,208,213,217,222,226,231,235,240,244,249,253,258,262,267,271,276,280,285,289,294,298,303,307,312,316,321
        ],
        earlyRome: [
          65,70,75,80,85,90,95,100,105,110,115,120,125,130,135,140,145,150,155,160,165,170,175,180,185,190,195,200,205,210,215,220,225,230,235,240,245,250,255,260,265,270,275,280,285,290,295,300,305,310,315,320,325,330,335,340,345,350,355,360
        ],
        romanEmpire: [
          74,80,85,91,96,102,107,113,118,124,129,135,140,146,151,157,162,168,173,179,184,190,195,201,206,212,217,223,228,234,239,245,250,256,261,267,272,278,283,289,294,300,305,311,316,322,327,333,338,344,349,355,360,366,371,377,382,388,393,399
        ],
        byzantineEra: [
          74,80,85,91,96,102,107,113,118,124,129,135,140,146,151,157,162,168,173,179,184,190,195,201,206,212,217,223,228,234,239,245,250,256,261,267,272,278,283,289,294,300,305,311,316,322,327,333,338,344,349,355,360,366,371,377,382,388,393,399
        ],
        ageOfTheFranks: [
          74,80,85,91,96,102,107,113,118,124,129,135,140,146,151,157,162,168,173,179,184,190,195,201,206,212,217,223,228,234,239,245,250,256,261,267,272,278,283,289,294,300,305,311,316,322,327,333,338,344,349,355,360,366,371,377,382,388,393,399
        ],
        feudalAge: [
          74,80,85,91,96,102,107,113,118,124,129,135,140,146,151,157,162,168,173,179,184,190,195,201,206,212,217,223,228,234,239,245,250,256,261,267,272,278,283,289,294,300,305,311,316,322,327,333,338,344,349,355,360,366,371,377,382,388,393,399
        ],
        iberianEra: [
          74,80,85,91,96,102,107,113,118,124,129,135,140,146,151,157,162,168,173,179,184,190,195,201,206,212,217,223,228,234,239,245,250,256,261,267,272,278,283,289,294,300,305,311,316,322,327,333,338,344,349,355,360,366,371,377,382,388,393,399
        ],
        kingdomOfSicily: [
          74,80,85,91,96,102,107,113,118,124,129,135,140,146,151,157,162,168,173,179,184,190,195,201,206,212,217,223,228,234,239,245,250,256,261,267,272,278,283,289,294,300,305,311,316,322,327,333,338,344,349,355,360,366,371,377,382,388,393,399
        ],
        highMiddleAges: [
          74,80,85,91,96,102,107,113,118,124,129,135,140,146,151,157,162,168,173,179,184,190,195,201,206,212,217,223,228,234,239,245,250,256,261,267,272,278,283,289,294,300,305,311,316,322,327,333,338,344,349,355,360,366,371,377,382,388,393,399
        ],
        earlyGothicEra: [
          74,80,85,91,96,102,107,113,118,124,129,135,140,146,151,157,162,168,173,179,184,190,195,201,206,212,217,223,228,234,239,245,250,256,261,267,272,278,283,289,294,300,305,311,316,322,327,333,338,344,349,355,360,366,371,377,382,388,393,399
        ],
        lateGothicEra: [
          74,80,85,91,96,102,107,113,118,124,129,135,140,146,151,157,162,168,173,179,184,190,195,201,206,212,217,223,228,234,239,245,250,256,261,267,272,278,283,289,294,300,305,311,316,322,327,333,338,344,349,355,360,366,371,377,382,388,393,399
        ]
      }).withOutput(ProductionOutputType.ALL_CURRENT_ERA_GOODS),
    )
  ]),
};

export default AncientLibrary;
